import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Auth } from 'aws-amplify';
import { initializeApp } from 'firebase/app';
import { getInstallations, getId } from 'firebase/installations';
import { firebaseConfig } from './firebaseConfig';
import { getApiBaseUrl } from './util/util';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://6204fd13b4f2866ebfa0e91dc12e5dfb@o479609.ingest.us.sentry.io/4511182125203456',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: process.env.REACT_APP_ENV,
  sendDefaultPii: true,
});

const app = initializeApp(firebaseConfig);

// Read persisted user type from localStorage (set by redux-persist)
const getPersistedUserType = () => {
  try {
    const persistedRoot = JSON.parse(localStorage.getItem('persist:root'));
    const appState = JSON.parse(persistedRoot.app);
    return appState.userType?.type || 'internal';
  } catch {
    return 'internal';
  }
};

const fid = await getId(getInstallations(app));

export const requestPermissionAndGetToken = async () => {
  try {
    let jwtToken = '';
    await Auth.currentSession()
      .then((data) => {
        jwtToken = data.idToken.jwtToken;
      })
      .catch((err) => console.log(err));

    fetch(`${getApiBaseUrl(getPersistedUserType())}/save_token?token=${encodeURIComponent(fid)}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: jwtToken,
      },
    })
      .then(() => {
        console.log('Successfully updated CURRENT TOKEN');
      })
      .catch(() => {
        console.log('Error TOKEN');
      });
  } catch (err) {
    console.error('Error getting token:', err);
    return null;
  }
};

if ('serviceWorker' in navigator) {
  requestPermissionAndGetToken();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
